import { render } from "./manual_verification_binding.html?vue&type=template&id=a28f5572&external"
import script from "./manual_verification_binding.js?vue&type=script&lang=js&external"
export * from "./manual_verification_binding.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__